module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certification"
  }, [_c('mt-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1000"
    },
    attrs: {
      "title": "资质认证"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/me')
      }
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notyet),
      expression: "notyet"
    }],
    staticClass: "authen-start"
  }, [_vm._v("\n      您暂未完成资质认证，请完成以下任务，进行认证吧。\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "authen authen-not",
    attrs: {
      "tag": "DIV",
      "to": {
        path: '/baseinfo'
      }
    }
  }, [_c('div', {
    class: {
      'authen-mark': true, 'hang': _vm.hangE, 'success': _vm.successE, 'failed': _vm.failedE, 'conduct': _vm.conductE
    }
  }, [_vm._v(_vm._s(_vm.examine))]), _vm._v(" "), _c('div', {
    staticClass: "authen-word"
  }, [_c('div', {
    staticClass: "authen-word-left"
  }, [_c('div', {
    staticClass: "authen-word-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "authen-word-details"
  }, [_vm._v("完善基本信息，让雇主更加了解你")])]), _vm._v(" "), _c('div', {
    staticClass: "authen-word-right"
  }, [_c('icon', {
    staticClass: "next",
    attrs: {
      "name": "chevron-right"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "authen authen-already",
    on: {
      "click": _vm.toRealname
    }
  }, [_c('div', {
    class: {
      'authen-mark': true, 'hang': _vm.hangA, 'success': _vm.successA, 'failed': _vm.failedA
    }
  }, [_vm._v(_vm._s(_vm.authentication))]), _vm._v(" "), _c('div', {
    staticClass: "authen-word"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authen-word-right"
  }, [_c('icon', {
    staticClass: "next",
    attrs: {
      "name": "chevron-right"
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authen-slogan"
  }, [_vm._v("\n      完成资质认证 "), _c('span', [_vm._v(" 立即开始接单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authen-word-left"
  }, [_c('div', {
    staticClass: "authen-word-title"
  }, [_vm._v("实名认证")]), _vm._v(" "), _c('div', {
    staticClass: "authen-word-details"
  }, [_vm._v("完善实名认证，让雇主更加信任你")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fc2dc82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my/certification.vue
// module id = 1292
// module chunks = 1